import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=7c0e008b&scoped=true"
import script from "./CompleteRegistration.vue?vue&type=script&lang=ts"
export * from "./CompleteRegistration.vue?vue&type=script&lang=ts"
import style0 from "./CompleteRegistration.vue?vue&type=style&index=0&id=7c0e008b&prod&lang=scss&scoped=true"
import style1 from "./CompleteRegistration.vue?vue&type=style&index=1&id=7c0e008b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0e008b",
  null
  
)

export default component.exports